import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

const eurHttpLink = createHttpLink({
  uri: `https://bluli.myshopify.com/api/2020-10/graphql.json`,
});

const eurAuthLink = setContext(() => ({
  headers: {
    'X-Shopify-Storefront-Access-Token': process.env.GATSBY_BLULI_EUR_ACCESS_TOKEN,
  },
}));

const dkkHttpLink = createHttpLink({
  uri: `https://bluli-dk.myshopify.com/api/graphql.json`,
});

const dkkAuthLink = setContext(() => ({
  headers: {
    'X-Shopify-Storefront-Access-Token': process.env.GATSBY_BLULI_DKK_ACCESS_TOKEN,
  },
}));

export const eurClient = new ApolloClient({
  link: eurAuthLink.concat(eurHttpLink),
  cache: new InMemoryCache(),
});
export const dkkClient = new ApolloClient({
  link: dkkAuthLink.concat(dkkHttpLink),
  cache: new InMemoryCache(),
});
